import { render, staticRenderFns } from "./CustomerRequestsCard.vue?vue&type=template&id=45d7e5a0&"
import script from "./CustomerRequestsCard.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports